import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getNewsletters = createAsyncThunk(
  'newsletters/get',
  async (manager, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const url = manager ? '/api/newsletters/' : '/api/news/'
      const { data } = await axios.get(url)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const saveNewsletter = createAsyncThunk(
  'newsletter/save',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/newsletters/${t.id}/`, t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const createNewsletter = createAsyncThunk(
  'newsletter/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/newsletters/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteNewsletter = createAsyncThunk(
  'newsletter/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/newsletters/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
